import { Wrench, CheckCircle } from "lucide-react";

const SolutionsSection = () => {
  const solutions = [
    {
      title: "Google Tag Manager (GTM) Setup & Auditing",
      description: "No more \"debug hell.\" We meticulously set up and audit your GTM containers to ensure every tag fires correctly, exactly when and how it should. This means reliable data from the start."
    },
    {
      title: "GA4 Setup, Auditing & Reporting",
      description: "Tired of reports that don't match reality? We implement GA4 correctly from the ground up, audit existing setups for accuracy, and help you configure reports that provide actionable insights you can trust."
    },
    {
      title: "Matomo Setup & Configuration",
      description: "For those prioritizing data ownership and privacy, we expertly set up and configure Matomo, ensuring your tracking is robust and aligned with your specific needs."
    },
    {
      title: "End-to-End Analytics Audits",
      description: "If you've tried fixing things yourself and they keep breaking, our comprehensive audits uncover the root causes of your tracking issues—from poor tag structure to missing DataLayer strategies—and provide a clear roadmap to resolution."
    },
    {
      title: "Conversion Tracking Setup & Audits",
      description: "Your conversions are the lifeblood of your business. We ensure all your critical conversions (scrolls, forms, funnels, purchases, etc.) are tracked accurately and reliably, providing the clarity you need to optimize your marketing efforts."
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-on-scroll">
          <div className="flex items-center justify-center gap-2 mb-6">
            <Wrench className="h-8 w-8 text-primary" />
            <h2 className="text-primary">How Tagnetica Solves Your Analytics Headaches</h2>
          </div>
          
          <p className="text-lg text-text-secondary mb-12 leading-relaxed">
            We specialize in transforming your analytics from a source of frustration into a reliable engine for growth. Here's how we help:
          </p>

          <div className="space-y-6 mb-12">
            {solutions.map((solution, index) => (
              <div 
                key={index}
                className="bg-accent/50 border border-primary/20 rounded-lg p-6 text-left animate-on-scroll hover:shadow-md transition-all duration-300"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="bg-primary/10 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                    <CheckCircle className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-text-primary mb-2">
                      <strong>{solution.title}</strong>
                    </h3>
                    <p className="text-text-secondary leading-relaxed">{solution.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection; 